import styled from 'styled-components';

export const ScDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;

  & > .text {
    font-size: 16px;
    line-height: 1.5;
  }

  & > .btn-container {
    width: 180px;
  }
`;
